// extracted by mini-css-extract-plugin
export default {"container":"OfzP_7","contentContainer":"iKz6ar"};